<template>
  <div class="row m0 pb30 next-event-container">
    <cms-block
      class="container px30 next-event-block"
      :identifier="'find-next-event'"
    />
  </div>
</template>

<script>
import CmsBlock from 'theme/components/core/blocks/Cms/Block'

export default {
  components: {
    CmsBlock
  }
}
</script>
<style lang="scss" scoped>
@import '~theme/css/variables/grid';

@include mobile {
  .next-event-block {
    /deep/ {
      h2 {
        margin-top: 17px;
      }
    }
  }
}

@include desktop {
  .next-event-block {
    padding-bottom: 42px;

    /deep/ {
      h2 {
        font-size: 36px;
        margin-bottom: 23px;
        margin-top: 27px;
      }

      .item-wrapper {
        h3 {
          font-size: 28px;
        }

        .fs14 {
          font-size: 18px;
        }

        .lh17 {
          line-height: 22px;
        }

        .item {
          margin-bottom: 0;

          .image-wrapper {
            img {
              padding-top: 10px;
              padding-right: 0;
              padding-left: 15px;
            }
          }

          &:nth-child(2) {
            padding-left: 0;
            padding-right: 0;

            .image-wrapper {
              order: 1;

              img {
                padding-left: 0;
                padding-right: 25px;
              }
            }

            .text-wrapper {
              order: 2;
              padding: 0;
            }
          }
        }
      }
    }
  }
}
</style>
